<template>
    <div class="Dashboard-view">

        <!-- <div class="row">

            <div class="col-md-3 mb-3">
                <el-card class="box-card">
                    <el-row>
                        <el-col :span="8">
                            <i class="widget-icon text-success opacity-5" :class="widget[0].icon"></i>
                        </el-col>
                        <el-col :span="16" class="widget-text-align">
                            <p class="sub-title">{{widget[0].title}}</p>
                            <p class="title">{{widget[0].num}}</p>
                        </el-col>
                    </el-row>
                </el-card>
            </div>

            <div class="col-md-3 mb-3">
                <el-card class="box-card">
                    <el-row>
                        <el-col :span="8">
                            <i class="widget-icon text-danger opacity-5" :class="widget[1].icon"></i>
                        </el-col>
                        <el-col :span="16" class="widget-text-align">
                            <p class="sub-title">{{widget[1].title}}</p>
                            <p class="title">{{widget[1].num}}</p>
                        </el-col>
                    </el-row>
                </el-card>
            </div>

            <div class="col-md-3 mb-3">
                <el-card class="box-card">
                    <el-row>
                        <el-col :span="8">
                            <i class="widget-icon text-warning opacity-5" :class="widget[2].icon"></i>
                        </el-col>
                        <el-col :span="16" class="widget-text-align">
                            <p class="sub-title">{{widget[2].title}}</p>
                            <p class="title">{{widget[2].num}}</p>
                        </el-col>
                    </el-row>
                </el-card>
            </div>

            <div class="col-md-3 mb-3">
                <el-card class="box-card">
                    <el-row>
                        <el-col :span="8">
                            <i class="widget-icon text-info opacity-5" :class="widget[3].icon"></i>
                        </el-col>
                        <el-col :span="16" class="widget-text-align">
                            <p class="sub-title">{{widget[3].title}}</p>
                            <p class="title">{{widget[3].num}}</p>
                        </el-col>
                    </el-row>
                </el-card>
            </div>

        </div>

        <div class="row">
            <div class="col-md-12 mb-3">
                <el-card class="box-card">
                    <area-chart :data="charts.multiple_series_data" :legend="charts.legend" :discrete="charts.discrete" :download="charts.download" :colors="charts.colors" :xtitle="charts.xtitle" :ytitle="charts.ytitle" :label="charts.label_chart" :min="charts.min" :max="charts.max" ></area-chart>
                </el-card>
            </div>
        </div> -->

        <div class="row">
            <div class="col-md-12">
                <h1>Coming Soon</h1>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    data() {
        return{
            widget: [
                {
                    icon: "el-icon-user",
                    title: "New Visit",
                    num: "1000"
                },
                {
                    icon: "el-icon-chat-line-square",
                    title: "New Subscribe",
                    num: "100"
                },
                {
                    icon: "el-icon-phone-outline",
                    title: "New Contact",
                    num: "50"
                },
                {
                    icon: "el-icon-message",
                    title: "New Message",
                    num: "500"
                }
            ],
            charts: {
                multiple_series_data:[
                    {
                        name: 'Visit',
                        data:{
                            'Jan': 5,
                            'Feb': 22,
                            'Mar': 80,
                            'Apr': 40,
                            'May': 50,
                            'Jun': 90,
                            'Jul': 10,
                            'Aug': 50,
                            'sep': 60,
                            'Oct': 55,
                            'Nov': 70,
                            'Dec': 70
                        }
                    },
                    {
                        name: 'Subscribe',
                        data:{
                            'Jan': 10,
                            'Feb': 50,
                            'Mar': 23,
                            'Apr': 42,
                            'May': 50,
                            'Jun': 80,
                            'Jul': 65,
                            'Aug': 74,
                            'sep': 22,
                            'Oct': 82,
                            'Nov': 65,
                            'Dec': 90
                        }
                    },
                    {
                        name: 'Contact',
                        data:{
                            'Jan': 0,
                            'Feb': 40,
                            'Mar': 33,
                            'Apr': 45,
                            'May': 60,
                            'Jun': 55,
                            'Jul': 25,
                            'Aug': 75,
                            'sep': 50,
                            'Oct': 75,
                            'Nov': 80,
                            'Dec': 70
                        }
                    },
                    {
                        name: 'Message',
                        data:{
                            'Jan': 0,
                            'Feb': 30,
                            'Mar': 23,
                            'Apr': 65,
                            'May': 70,
                            'Jun': 45,
                            'Jul': 15,
                            'Aug': 35,
                            'sep': 50,
                            'Oct': 65,
                            'Nov': 70,
                            'Dec': 80
                        }
                    }
                ],
                download: true,
                xtitle: 'Month',
                ytitle: 'Number',
                legend: 'bottom',
                discrete: true,
                colors: ["#28a745" , "#dc3545" , "#ffc107" , "#17a2b8"]
            }
        }
    }
}
</script>

<style>
    .widget-icon{
        font-size: 80px;
    }
    .widget-text-align{
        text-align: right;
    }
    .sub-title{
        color: rgba(0,0,0,0.45);
        font-size: 18px;
    }
    .title{
        color: rgb(0,0,0);
        font-weight: bold;
        font-size: 30px;
    }
    .opacity-5{
        opacity: 0.5;
    }
    
</style>